import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }

import { searchPatient } from "@/api/patient";
import { reactive, ref, UnwrapRef, onMounted, VNode, h } from "vue";
import AddPatient from "../patient/AddPatient.vue";
import {formatDateTime, getDate} from "@/components/ts/components";
import STATUS from "@/components/model/enum"
import { useRouter } from 'vue-router'
// import { getSrcEnum } from "@/api/leads";
import dayjs, { Dayjs } from 'dayjs';
import { searchProcess, startProcess } from "@/api/workflow_process";
import message from "ant-design-vue/lib/message";
import { dictList } from "@/api/user";
import { copyToClip } from "@/utils/clip";
import mobileView from "@/components/view/mobileView.vue";

type RangeValue = [Dayjs, Dayjs];

interface Data {
    loading: boolean;
    dataSource: any[];
    expand: boolean;
    addHospitalvisible: boolean;
    pagination: any,
    patientId: string | number,
    disabled: boolean,
    title: string,
    patientType: string,
    sourceType: any[],
    tagList: any[],
    ranges: any,
    menuList: any[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Patient',
  props: {
    type: {
        type: Number,
        default: 1
    },
    clinicId: {
        type: String,
        default: ""
    },
    dentistId: {
        type: String,
        default: ""
    }
},
  setup(__props) {

const prop = __props;

const data: UnwrapRef<Data> = reactive({
    title: '新建患者',
    loading: true,
    dataSource: [],
    expand: false,
    addHospitalvisible: false,
    pagination: {
        size: "large",
        current: 1,
        pageSize: 10,
        total: 10,
        pageSizeOptions: ["10", "20", "30"], //可选的页面显示条数
        showTotal: (total: string) => {
            console.log(total);
            return " 共" + total + "条";
        }, //展示每页第几条至第几条和总数
        hideOnSinglePage: false, // 只有一页时是否隐藏分页器
        showSizeChanger: true, //是否可以改变pageSize
    },
    patientId: "",
    disabled: false,
    patientType: 'add',
    sourceType: [],
    tagList: [],
    ranges: {
        '今天': [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss')] as RangeValue,
        '本周': [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss').endOf('week')] as RangeValue,
        '本月': [dayjs('00:00:00', 'HH:mm:ss'), dayjs('23:59:59', 'HH:mm:ss').endOf('month')] as RangeValue,
    },
    menuList: [],
});

// noinspection JSVoidFunctionReturnValueUsed
const columns = ref([
    {
        title: "序号",
        dataIndex: "key",
        key: "key",
        width: 40,
        customRender: ({ index }: any) => `${index + 1}`,
        fixed: 'left'
    },
    {
        title: "资料",
        children: [
            {
                title: "姓名",
                dataIndex: "name",
                key: "name",
                width: 80,
                customRender: ({ record }: any) => `${record.name}`,
            },
            {
                title: "性别",
                dataIndex: "gender",
                key: "gender",
                width: 50,
                customRender: ({ record }: any) => `${STATUS('genderType').getDesc(record.gender)}`,
            },
            {
                title: "出生日期",
                dataIndex: "born",
                key: "born",
                width: 130,
                customRender: ({ record }: any) => `${record.born ? getDate(record.born) : ''}`,
            },
            {
                title: "电话",
                dataIndex: "mobile",
                key: "mobile",
                width: 130,
                customRender: function ({ record }: any): VNode {
                    return h(mobileView,
                        {
                            mobile: record.mobile,
                            title: '点击复制',
                            onClick: () => copyToClip(record.mobile),
                        },
                        () => { return record.mobile })
                },
            },
            {
                title: "病例号",
                dataIndex: "patientCode",
                key: "patientCode",
                width: 150,
                customRender: function ({ record }: any): VNode {
                    return h(mobileView,
                        {
                            mobile: record.patientCode,
                            title: '点击复制',
                            onClick: () => copyToClip(record.patientCode),
                        },
                        () => { return record.patientCode })
                },
            }

        ]
    },
    {
        title: "医生",
        children: [
            {
                title: "所属医生",
                dataIndex: "dentistsName",
                key: "dentistsName",
                width: 100,
                customRender: ({ record }: any) => `${record.dentists ? record.dentists[0].name : ''}`,
            },
            {
                title: "医生手机号",
                dataIndex: "dentistsMobile",
                key: "dentistsMobile",
                width: 130,
                customRender: function ({ record }: any): VNode {
                    return h(mobileView,
                        {
                            title: '点击复制',
                            mobile: record.dentists ? record.dentists[0].mobile : '',
                            onClick: () => copyToClip(record.dentists ? record.dentists[0].mobile : ''),
                        },
                        () => { return record.dentists ? record.dentists[0].mobile : '' })
                },
            },
            {
                title: "所属医院",
                dataIndex: "clinicName",
                key: "clinicName",
                width: 130,
                customRender: ({ record }: any) => `${record.clinics && record.clinics[0] ? record.clinics[0].shortName : ''}`,
            },
        ]
    },
    {
        title: "预约时间",
        children: [
            {
                title: "开始时间",
                dataIndex: "fromTime",
                key: "fromTime",
                width: "12%",
                customRender: ({ record }: any) => `${record.fromTime ? formatDateTime(record.fromTime): ''}`,
            },
            {
                title: "结束时间",
                dataIndex: "toTime",
                key: "toTime",
                width: "12%",
                customRender: ({ record }: any) => `${record.toTime ? formatDateTime(record.toTime) : ''}`,
            }
        ]
    },
    {
        title: "来源",
        dataIndex: "srcName",
        key: "srcName",
        width: 80,
        filters: [],
    },
    {
        title: "标签",
        dataIndex: "tagNames",
        key: "tagNames",
        width: 80,
        filters: [],
    },
    {
        title: "订单",
        dataIndex: "orderCnt",
        key: "orderCnt",
        width: 50
    },
    {
        title: "操作",
        dataIndex: "operation",
        width: "15%",
        fixed: 'right',
    },
])


const formState = reactive({
    type: "",
    keyword: "",
    mobile: "",
    srcIds: [],
    tagIds: [],
    clinicId: "",
    dentistId: "",
    dentistName: "",
    clinicName: "",
    value: ref<RangeValue>()
});


console.log('type', prop.type);


const handleTableChange = (ipagination: any, value: any) => {
    console.log(ipagination, '切换来源', value);
    data.pagination.pageSize = ipagination.pageSize;
    data.pagination.current = ipagination.current;
    formState.srcIds = value.srcName
    formState.tagIds = value.tagNames
    onSearch();
};

const onFinish = (values: any) => {
    console.log("Received values of form: ", values);
    console.log("formState: ", formState);
    data.pagination.current = 1
    onSearch();
};

function onSearch() {
    data.loading = true;
    searchPatient({
        page: {
            pageSize: data.pagination.pageSize,
            currPage: data.pagination.current,
        },
        keyword: formState.keyword,
        mobile: formState.mobile,
        clinicId: formState.clinicId,
        dentistId: formState.dentistId,
        startTime: formState.value,
        srcIds: formState.srcIds,
        tagIds: formState.tagIds,
    }).then((res: { records: number; data: any[] }) => {
        data.loading = false;
        data.dataSource = res ? res.data : [];
        data.pagination.total = res ? res.records : 0;
    });
}

const onEdit = (id: string) => {
    console.log(id);
    data.title = '修改患者'
    data.patientId = id
    data.addHospitalvisible = true;
    data.disabled = false
    data.patientType = "update"
};
const addHandle = () => {
    data.title = "新增患者"
    data.patientId = ""
    data.addHospitalvisible = true;
    data.disabled = false
    data.patientType = "add"
};
const router = useRouter()
const onDdetails = (id: string) => {
    console.log("查看详情", id);
    // router.push('/patient/patientInfo')
    router.push({
        path: '/patient/patientInfo',
        query: {
            id
        }
    })
}
const onCancel = () => {
    console.log("取消");
    data.addHospitalvisible = false;
    onSearch();
};
const addPatientRef = ref()
const onSubmit = () => {
    console.log("确认");
    addPatientRef.value.onSubmit()
}

const searchLeasSrc = () => {
    dictList({
        "dictCodes": []
    }).then((res: any[]) => {
        console.log(res);
        data.sourceType = []
        data.tagList = []
        res.forEach(element => {
            element.text = element.name
            element.value = element.id
            if (element.dictCode == 'CUSTOMER_TYPE') {
                data.sourceType.push(element)
            } else if (element.dictCode == 'CUSTOMER_TAG') {
                data.tagList.push(element)
            }
        });
        columns.value[4].filters = data.sourceType
        columns.value[5].filters = data.tagList
    });
}

const handleMenuClick = (e: any, record: any) => {
    console.log(e);
    let option: any = {
        "processKey": e.key,
        "params": {
            "client": "WEB"
        },
    }
    switch (e.key) {
        case 'P01':
            option.params.relatedId = record.id;
            option.params["relatedType"] = 1;
            option.params["type"] = 1;
            break;
        case 'P02':
            option.params.relatedId = record.id;
            option.params["relatedType"] = 1;
            option.params["type"] = 2;
            break;
        case 'P04':
        case 'P05':
        case 'P06':
        case 'P07':
        case 'P08':
            option.params.patientId = record.id;
            break;
        case 'P09':
            option.params.relatedId = record.id;
            option.params["relatedType"] = 1;
            break;
        case 'P10':
            option.params.relatedId = record.id;
            option.params["relatedType"] = 1;
            break;
        default:
            break;
    }
    startProcess(option).then(() => {
        message.success('开启成功')
        router.push({
            path: "/home",
        });
    })
}
const getMenuList = (id: string) => {
    console.log(id);
    searchProcess().then((res: any[] | null) => {
        data.menuList = [];
        if (null !== res) {
            data.menuList = res
        }
    });
}

onMounted(() => {
    formState.clinicId = prop.clinicId
    formState.dentistId = prop.dentistId
    onSearch();
    searchLeasSrc();
})



return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_btnPermission = _resolveDirective("btnPermission")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type == 1)
      ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          ref: "formRef",
          name: "advanced_search",
          class: "ant-advanced-search-form",
          model: formState,
          onFinish: onFinish
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_row, { gutter: 24 }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: formState.keyword,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((formState.keyword) = $event)),
                          placeholder: "关键字",
                          "allow-clear": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_form_item, { label: "手机号" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: formState.mobile,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((formState.mobile) = $event)),
                          placeholder: "手机号",
                          "allow-clear": ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 8 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_range_picker, {
                      value: formState.value,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((formState.value) = $event)),
                      style: {"width":"400px"},
                      ranges: data.ranges,
                      format: "YYYY/MM/DD HH:mm:ss",
                      "show-time": {
                            hideDisabledOptions: true,
                            defaultValue: [_unref(dayjs)('00:00:00', 'HH:mm:ss'), _unref(dayjs)('23:59:59', 'HH:mm:ss')],
                        }
                    }, null, 8, ["value", "ranges", "show-time"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, { span: 4 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      "html-type": "submit"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查询")
                      ]),
                      _: 1
                    }),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "primary",
                      style: {"margin":"0 8px"},
                      onClick: addHandle
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("新增 ")
                      ]),
                      _: 1
                    })), [
                      [_directive_btnPermission, 'patient:add']
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_table, {
      bordered: "",
      dataSource: data.dataSource,
      columns: columns.value,
      loading: data.loading,
      pagination: data.pagination,
      onChange: handleTableChange,
      scroll: { x: 1500, y: 400 },
      size: "small"
    }, {
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'tagNames')
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(record.tagNames, (item) => {
              return (_openBlock(), _createBlock(_component_a_tag, {
                color: "cyan",
                key: item
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item), 1)
                ]),
                _: 2
              }, 1024))
            }), 128))
          : _createCommentVNode("", true),
        (column.dataIndex === 'operation')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (__props.type == 1)
                ? _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    type: "link",
                    onClick: ($event: any) => (onEdit(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("修改")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])), [
                    [_directive_btnPermission, 'patient:update']
                  ])
                : _createCommentVNode("", true),
              _createVNode(_component_a_button, {
                type: "link",
                onClick: ($event: any) => (onDdetails(record.id))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("详情")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                overlay: _withCtx(() => [
                  _createVNode(_component_a_menu, {
                    onClick: (e) => handleMenuClick(e, record)
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.menuList, (item) => {
                        return (_openBlock(), _createBlock(_component_a_menu_item, {
                          key: item.code,
                          disabled: item.code == 'P03' || item.code == 'P11' || item.code == 'P07' || item.code == 'P08'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["disabled"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_a_button, {
                    type: "link",
                    onClick: ($event: any) => (getMenuList(record.id))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 订单 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 2
              }, 1024)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination"]),
    (data.addHospitalvisible)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 1,
          visible: data.addHospitalvisible,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((data.addHospitalvisible) = $event)),
          title: data.title,
          width: "40%",
          onCancel: onCancel,
          onOk: onSubmit,
          "ok-button-props": { disabled: data.disabled }
        }, {
          default: _withCtx(() => [
            _createVNode(AddPatient, {
              onOnCancel: onCancel,
              id: data.patientId,
              type: data.patientType,
              ref_key: "addPatientRef",
              ref: addPatientRef
            }, null, 8, ["id", "type"])
          ]),
          _: 1
        }, 8, ["visible", "title", "ok-button-props"]))
      : _createCommentVNode("", true)
  ]))
}
}

})